import React from 'react'

/**
 * SVG-пирог завершённости сервиса.
 *
 * Без зависимостей — просто SVG circle с stroke-dasharray.
 * pct: 0..100, size: пиксели, stroke: толщина дуги.
 */
function CompletionPie({
  pct = 0,
  size = 56,
  stroke = 6,
  color = 'var(--color-accent)',
  trackColor = 'var(--color-border)',
  showLabel = true,
  fontSize = 13,
  ariaLabel,
}) {
  const safe = Math.max(0, Math.min(100, Math.round(pct)))
  const radius = (size - stroke) / 2
  const circumference = 2 * Math.PI * radius
  const offset = circumference * (1 - safe / 100)

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={ariaLabel || `${safe}%`}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={trackColor}
        strokeWidth={stroke}
        fill="none"
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={color}
        strokeWidth={stroke}
        fill="none"
        strokeLinecap="round"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
        style={{ transition: 'stroke-dashoffset 0.5s ease' }}
      />
      {showLabel && (
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="central"
          fontSize={fontSize}
          fontWeight="600"
          fill="var(--color-text)"
          style={{ fontFamily: 'var(--font-base, Inter), sans-serif' }}
        >
          {safe}%
        </text>
      )}
    </svg>
  )
}

export default CompletionPie
